if (!customElements.get('product-sku')) {
  customElements.define(
    'product-sku',
    class ProductSku extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.value = this.querySelector('[data-sku-value]');

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId) return;

          const sku = data.variant?.sku ?? '';
          if (this.value) this.value.textContent = sku;
          this.classList.toggle('hidden', sku === '');
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }
    }
  );
}
